'use client';

import React, { useEffect } from 'react';

import { conf } from '../../../../../confg';
import * as axios from 'axios';
import { GenericInputField } from '../../../components/Forms/GenericInputField/GenericInputField';
import { SelectField } from '../../../components/Forms/GenericInputField/SelectField';
import { connect } from 'react-redux';

const FormFields = ({ errors = {}, touched = {}, name, lastName }) => {
  const [states, setStates] = React.useState([]);
  const [cities, setCities] = React.useState([]);
  const [selectedState, setSelectedState] = React.useState(null);
  const [isChecked, setIsChecked] = React.useState(false);
  const get_states = () => {
    axios({
      url: conf.server_url + 'logito/get_states',
      method: 'GET',
    }).then((e) => {
      setStates(e.data.data);
    });
  };

  const get_cities = () => {
    var settings = {
      url: conf.server_url + 'logito/get_cities',
      method: 'POST',
      timeout: 0,
      processData: false,
      mimeType: 'multipart/form-data',
      contentType: false,
      data: { state_id: selectedState },
    };

    axios(settings).then((e) => {
      setCities(e.data.data);
    });
  };
  useEffect(() => {
    get_states();
  }, []);

  useEffect(() => {
    get_cities();
  }, [selectedState]);

  return (
    <>
      <div className='form-group'>
        <label style={{ display: 'flex', flexDirection: 'row-reverse', alignItems: 'center', marginBottom: '10px', textAlign: 'right' }}>
          <input type='checkbox' checked={isChecked} onChange={() => setIsChecked(!isChecked)} />
          <span style={{ marginInline: '10px' }}>گیرنده سفارش خودم هستم</span>
        </label>
      </div>
      <GenericInputField
        inputValue={isChecked ? name : ''}
        label={'نام گیرنده'}
        name='entry_firstname'
        type='text'
        placeholder={'نام گیرنده را وارد کنید'}
        errors={errors}
        touched={touched}
      />
      <GenericInputField
        inputValue={isChecked ? lastName : ''}
        label={'نام خانوادگی گیرنده'}
        name='entry_lastname'
        type='text'
        placeholder={'نام خانوادگی خود را وارد کنید'}
        errors={errors}
        touched={touched}
      />
      <SelectField
        label={'برچسب'}
        name={'label'}
        errors={errors}
        touched={touched}
        options={[
          { value: 'خانه', label: 'خانه' },
          { value: 'دفتر', label: 'دفتر' },
        ]}
        onChange={(e) => {}}
      />

      <SelectField
        label={'استان'}
        name={'state_id'}
        errors={errors}
        touched={touched}
        onChange={(e) => {
          setSelectedState(e.target.value);
        }}
        options={states.map((state) => ({ value: `${state.Id}-${state.Title}`, label: state.Title }))}
      />
      <SelectField
        label={'شهر'}
        name={'city_id'}
        errors={errors}
        touched={touched}
        options={cities.map((city) => ({ value: `${city.id}-${city.Title}`, label: city.Title }))}
        onChange={(e) => {}}
      />
      <GenericInputField label={'آدرس'} name='entry_street_address' type='text' placeholder={'مثال :بزرگراه...-خیابان....-کوچه.....'} errors={errors} touched={touched} />
      <GenericInputField label={'پلاک'} name='pelak' type='text' placeholder={'مثال : 145'} errors={errors} touched={touched} />
      <GenericInputField label={'واحد'} name='vahed' type='text' placeholder={'مثال : 5'} errors={errors} touched={touched} />
      <GenericInputField label={'کد پستی'} name='entry_postcode' type='text' placeholder={'مثال:1473693265'} errors={errors} touched={touched} />
    </>
  );
};
const MapStateToProps = (state) => ({
  name: state.user.name,
  lastName: state.user.family,
});
export default connect(MapStateToProps)(FormFields);
